'use strict';

var ConversationIdInterceptorConfig = function ConversationIdInterceptorConfig($httpProvider) {
  $httpProvider.interceptors.push('AddConversationIdToHeaderFactory');
};
ConversationIdInterceptorConfig.$inject = ['$httpProvider'];
module.exports = ConversationIdInterceptorConfig;